export default "__VITE_ASSET__Cv4AhZM5__"